import { Component, OnInit } from '@angular/core';
import { Regulations } from '../../models/regulation';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-regulation-details',
  templateUrl: './regulation-details.component.html',
  styleUrls: ['./regulation-details.component.scss']
})
export class RegulationDetailsComponent implements OnInit {

  model = {} as Regulations;
  constructor(
    private route: Router,
    private diag: NbDialogRef<RegulationDetailsComponent>,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

}
